import { render, staticRenderFns } from "./ActivityBannerModule.vue?vue&type=template&id=72ae78b7&scoped=true"
import script from "./ActivityBannerModule.vue?vue&type=script&lang=js"
export * from "./ActivityBannerModule.vue?vue&type=script&lang=js"
import style0 from "./ActivityBannerModule.vue?vue&type=style&index=0&id=72ae78b7&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72ae78b7",
  null
  
)

export default component.exports